export default "__VITE_ASSET__C42GK7q5__"